<template>
  <div class="wrapper flex column" v-if="showTag">
    <div class="header flex0 flex color_fff">
      <v-icon-arrow-left class="flex0" @click.native="onHide"></v-icon-arrow-left>
      <div class="flex1 ellipsis">{{ pic.name }} ({{ curr + 1 }}/{{ pics.length }})</div>
    </div>
    <div class="flex1 scan-box flex overflow-hidden">
      <van-swipe class="custom-swipe" @change="onChange" ref="swipe">
        <van-swipe-item v-for="(pic,idx) in pics" :key="idx">
          <img :src="pic.src" alt="">
        </van-swipe-item>
        <template #indicator>

        </template>
      </van-swipe>
    </div>
    <div class="list-box flex0">
      <ul class="flex pl10">
        <li v-for="(pic,index) in pics" :key="index" class="flex0 flex"
            :class="[index?'ml10':'',curr===index?'current':'']"
        >
          <img :src="pic.src" alt="" class="flex0" @click="onImgClick(index)">
        </li>
      </ul>
    </div>
    <div class="flex0 pt10 pb10 pr15 pl15 footer flex" v-if="showSendBtn">
      <van-button type="info" size="small" round @click="onSend">发 送</van-button>
    </div>
  </div>
</template>

<script>
import VIconArrowLeft from "@/plugins/v-icon-arrow-left";
import readfile from "@/utils/readfile";

export default {
  name: "mul-pic-scan",
  components: {VIconArrowLeft},
  data() {
    return {
      duration: 0,
      showTag: false,
      files: [],
      curr: 0,
      pics: [],
      showSendBtn: true
    }
  },
  computed: {
    pic() {
      return this.pics[this.curr] || {};
    }
  },
  methods: {
    /**
     * 打开
     * @param options
     * @param options.curr
     * @param options.showSendBtn
     * @returns {void}
     */
    async open(options) {
      this.showTag = true;
      const pics = [];
      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i];
        pics.push({
          file,
          src: file.url ? file.url : await readfile(file),
          name: file.name
        })
      }
      this.pics = pics;
      if ('showSendBtn' in options) this.showSendBtn = options.showSendBtn;
      if (options.curr) this.onImgClick(options.curr);
    },
    close() {
      this.showTag = false;
    },
    onChange(index) {
      this.curr = index;
    },
    onHide() {
      this.close();
      this.$emit('hide');
    },
    onImgClick(index) {
      this.curr = index;
      this.$refs.swipe.swipeTo(index);
    },
    onSend() {
      this.close();
      this.$emit("send", this.pics);
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../common/public";

.wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #000000;
}

.header {
  @include h_lh(45px);

  > font {
    width: px2rem(45px);
    text-align: center;
  }
}

.scan-box {
  img, video {
    max-height: 100%;
    max-width: 100%;
  }
}

.list-box {
  width: 100%;
  overflow-x: auto;

  .current {
    img {
      border: 2px solid $mainColor;
      width: 46px;
      height: 46px;
    }
  }

  img, li {
    width: 50px;
    height: 50px;
  }
}

.footer {
  justify-content: flex-end;
}

.custom-swipe {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
}

.van-swipe-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/mul-pic-scan.vue